// src/components/TemplateBrowser.jsx
import React, { useEffect, useState } from 'react';
import { getAllTemplates } from '../utils/supabaseUtils';
import './TemplateBrowser.css';

function TemplateBrowser({ onSelectTemplate, onClose }) { // Added onClose prop
  const [templates, setTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const data = await getAllTemplates();
        const formattedTemplates = data.map(record => ({
          id: record.id,
          name: record.name || 'Untitled Template',
          updatedAt: record.updated_at || new Date().toISOString(),
          thumbnailUrl: record.thumbnail_url || '', // Use thumbnail if available
          hasPlaceholders: record.scene_data?.includes('"is_placeholder":true') || false
        }));
        setTemplates(formattedTemplates);
      } catch (error) {
        console.error('Error fetching templates:', error);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTemplates();
  }, []);

  if (isLoading) return <div className="template-browser">Loading templates...</div>;
  if (error) return <div className="template-browser">Error: {error}</div>;

  return (
    <div className="template-browser">
      <div className="template-browser-header">
        <h2>Templates</h2>
        <button className="close-button" onClick={onClose}>✕</button>
      </div>
      {templates.length === 0 ? (
        <div className="no-templates">No templates available</div>
      ) : (
        <div className="templates-grid">
          {templates.map(template => (
            <div
              key={template.id}
              className="template-card"
              onClick={() => onSelectTemplate(template.id)}
            >
              <div className="template-thumbnail">
                {template.thumbnailUrl ? (
                  <img src={template.thumbnailUrl} alt={template.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <div className="placeholder-image" />
                )}
                {template.hasPlaceholders && (
                  <span className="placeholder-indicator">P</span>
                )}
              </div>
              <div className="template-name">{template.name}</div>
              <div className="template-date">
                Last updated: {new Date(template.updatedAt).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TemplateBrowser;